import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { authApi } from '@/api';
import { AxiosResponse } from 'axios';
import { MyProfile } from '@/types/profile';

interface AuthStore {
    user: MyProfile | null;
    login: (authData: any) => Promise<any | unknown>;
    logout: () => Promise<void>;
    setProfile: (user: any) => void;
    emptyFields: () => boolean;
    getUser: () => MyProfile | null;
    completeRegistration: () => Promise<AxiosResponse>;
    partiallyCompleteRegistration: () => Promise<AxiosResponse>;
    profileWasRemovedError: boolean | null,
    setProfileWasRemovedError: (val: boolean | null) => void;
}

export const useAuth = create<AuthStore>()(
    devtools(
        immer((set, get) => ({
            user: null,
            telegramWebAppInitData: null,
            login: async (authData: any) => {
                return null;
            },
            setProfile: (user: MyProfile) => {
                set({ user });
            },
            logout: async () => {
                await authApi.logout();
                set({ user: null });
            },
            emptyFields: () => {
                const getUser = get().user;
                console.log('getUser empryFields', get().user)
                if (!getUser) return false;
                return (
                    !getUser?.dob &&
                    // !getUser?.travel_plans &&
                    !getUser?.photos.length &&
                    !getUser?.gender &&
                    !getUser?.public_name
                );
            },
            getUser: () => get().user,
            completeRegistration: async () => await authApi.completeRegistration(),
            partiallyCompleteRegistration: async () => await authApi.partiallyCompleteRegistration(),
            profileWasRemovedError: null,
            setProfileWasRemovedError: (val: boolean | null) => {
                set({
                    profileWasRemovedError: val
                })
            },
        })),
    ),
);
